import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { PencilIcon } from '@heroicons/react/24/solid'
import { TrashIcon } from '@heroicons/react/24/outline'
import { EmptyValuePlaceholder, Spinner } from "@/components/ui"
import { formatDate, formatPrice } from '@/utils/formatters'

import { useDetailContext } from '@/components/DetailTemplate'
import FacturationEntity from '@/components/shared/FacturationEntity'
import { selectPrestataireById } from '../../prestataires/prestatairesSlice'
import { deleteEntretien, getFactureStatusLabel, setEntretienInEdition } from '../../entretiens/entretiensSlice'
import { getFacturationEntiteValues } from '../../interventions/interventionsSlice'

import Prestataire from '../../prestataires/Show'

export default ({item}) => {
  const dispatch = useDispatch()
  const detailContext = useDetailContext()
  const deleting = useSelector( state => state.entretiens.loadingStatus.delete )
  const prestataire = useSelector(state => selectPrestataireById(state, item.prestataire_id ))
  const [ showConfirmDialog, setShowConfirmDialog ] = useState(false)
  const [ deleteFired, setDeleteFired ] = useState(false)
  
  const facturationEntities = getFacturationEntiteValues(item)

  const handleEditClick = () => {
    dispatch(setEntretienInEdition(item))
    detailContext.setModalVisible(true)
  }

  const handleDeleteClick = (e) => {
    setShowConfirmDialog(true)
  }

  const confirmDelete = () => {
    setDeleteFired(true)
    dispatch(deleteEntretien(item))
  }

  const cancelDelete = () => {
    setShowConfirmDialog(false)
  }

  useEffect(() => {
    if(!deleting && deleteFired) {
      setShowConfirmDialog(false)
    }
  }, [deleting, deleteFired])
  
  return (
    <tr>
      <td>
        <EmptyValuePlaceholder value={item.entretien_type?.nom} className="capitalize" />
      </td>
      <td>{ prestataire ? 
          <Prestataire item={prestataire} withLabel={false} /> :
          <EmptyValuePlaceholder />
      }
      </td>
      <td>
        <EmptyValuePlaceholder value={formatDate(item.date_prestation)} />
      </td>
      <td><EmptyValuePlaceholder value={formatPrice(item.montant)}/></td>
      <td>
        <FacturationEntity entity={item.entite_facturable} 
          entitiesList={facturationEntities} 
          address={item.facture_adresse} 
        />
      </td>
      <td><EmptyValuePlaceholder value={getFactureStatusLabel(item.statut_facture)}/></td>
      <td className="flex gap-2">
        <button 
          className="btn btn-sm btn-ghost btn-square p-2 hover:bg-primary-400" 
          title="Modifier l'entretien"
          onClick={handleEditClick}
        >
          <PencilIcon />
        </button>
        <button 
          className="btn btn-sm btn-ghost btn-square p-2 hover:bg-primary-400" 
          title="Modifier l'entretien"
          onClick={handleDeleteClick}
        >
          <TrashIcon />
        </button>
        {showConfirmDialog && (
            <dialog open className="modal">
              <div className="modal-box">
                <h3 className="font-bold text-lg">Confirmer la suppression</h3>
                <p className="py-4">Êtes-vous sûr de vouloir supprimer cet entretien ?</p>
                <p className="py-4 text-center">
                  { item.entretien_type?.nom }{item.date_prestation ? ` du ${formatDate(item.date_prestation)} ` : ' '}
                  {item.montant ? ` pour un montant de ${formatPrice(item.montant)}` : ''}
                </p>
                <div className="modal-action">
                  { deleting ? 
                    <button className="btn btn-secondary"><Spinner /></button> :
                    <button onClick={confirmDelete} className="btn btn-secondary">
                      Supprimer
                    </button>
                  }
                  <button onClick={cancelDelete} className="btn btn-outline">Annuler</button>
                </div>
              </div>
            </dialog>
          )}
      </td>
    </tr>
  )
}